export const organizationDocumentMaxFileSizeBytes = 5 * 1024 * 1024

export const organizationDocumentUploadTimeoutMs = 120_000
